<ui-breadcrumb-nav ariaLabel="Breadcrumb">
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId()]">
      <ng-icon name="heroHome" size="20" class="!block" />
      <span class="sr-only">{{
        'cockpit.locations.details.breadcrumb.dashboard' | transloco
      }}</span>
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a [routerLink]="['/organizations', organizationId(), 'locations']">
      {{ 'cockpit.locations.details.breadcrumb.locations' | transloco }}
    </a>
  </ui-breadcrumb>
  <ui-breadcrumb>
    <a
      [routerLink]="['/organizations', organizationId(), 'locations', locationId()]"
      aria-current="page"
    >
      {{ 'cockpit.locations.details.pageTitle' | transloco }}
    </a>
  </ui-breadcrumb>
</ui-breadcrumb-nav>
